import { BaseIcon } from '../BaseIcon';
import type { BaseIconProps } from '../BaseIcon';

type EditIconProps = Omit<BaseIconProps, 'children'>;

export const EditIcon = ({ ...props }: EditIconProps) => (
  <BaseIcon width="24" height="24" viewBox="0 0 24 24" hasLegacyStrokeStyles={true} {...props}>
    <g fill="none" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 8L18.7929 7.20711C19.1834 6.81658 19.1834 6.18342 18.7929 5.79289L18.2071 5.20711C17.8166 4.81658 17.1834 4.81658 16.7929 5.20711L16 6L18 8Z" />
      <path d="M7 19L16 10L14 8L5 17V19.001L7 19Z" />
    </g>
  </BaseIcon>
);
